<template>
    <div>
        <div class="search-box">
            <div class="input-item">
                <span class="label">变更时间</span>
                <DatePicker
                    type="daterange"
                    split-panels
                    separator="至"
                    :transfer="true"
                    placement="bottom"
                    format="yyyy-MM-dd"
                    placeholder="选择日期"
                    @on-change="searchParams.date = $event"
                >
                </DatePicker>
            </div>

            <div class="input-item">
                <span class="label">名称</span>
                <Input v-model="searchParams.fieldName" placeholder="请输入" clearable />
            </div>

            <div class="input-item">
                <span class="label">变更人</span>
                <Select v-model="searchParams.updateId" :transfer="true" clearable filterable>
                    <Option :value="item.createBy" v-for="(item, index) in changedByList" :key="index">{{ item.name }}</Option>
                </Select>
            </div>

            <div class="btn-item">
                <Button type="primary" @click="search()">搜索</Button>
            </div>
        </div>

        <div class="table-box template-table">
            <loading :isShow="tableLoading" />
            <Table :columns="columns" :data="tableData" v-if="tableData.length">
                <template slot-scope="{ row }" slot="beforeChange">
                    {{ row.oldStatusName }}
                </template>

                <template slot-scope="{ row }" slot="afterChange">
                    {{ row.newStatusName }}
                </template>
            </Table>
            <no-data v-else style="margin-top:10px;"></no-data>
        </div>

        <div class="pageBox">
            <Page
                :total="total"
                :current="searchParams.pageNo"
                :page-size="searchParams.pageSize"
                show-total
                @on-change="pageChange"
                style="text-align: center"
            />
        </div>
    </div>
</template>

<script>
import filters from '@/api/filter';
export default {
    name: 'status',
    props: ['policyNo'],
    data() {
        return {
            tableLoading: false,
            columns: [
                {
                    title: '序号',
                    type: 'index',
                    align: 'center',
                    width: 60
                },
                {
                    title: '名称',
                    key: 'fieldName',
                    align: 'center',
                    minWidth: 200,
                    ellipsis: true,
                    tooltip: true
                },
                {
                    title: '变更前',
                    align: 'center',
                    minWidth: 240,
                    slot: 'beforeChange'
                },
                {
                    title: '变更后',
                    align: 'center',
                    minWidth: 240,
                    slot: 'afterChange'
                },
                {
                    title: '变更人',
                    align: 'center',
                    minWidth: 150,
                    render(h, params) {
                        const result = params.row.operator;
                        return <span>{result ? result : '-'}</span>;
                    }
                },
                {
                    title: '变更时间',
                    align: 'center',
                    minWidth: 150,
                    render(h, params) {
                        const result = params.row.createTime;
                        return <span>{filters.filterTime(result, 'YYYY-MM-DD HH:mm') || '-'}</span>;
                    }
                }
            ],
            tableData: [],
            changedByList: [],
            total: 0,
            searchParams: {
                pageNo: 1,
                pageSize: 10,
                type: '2'
            },
            RECEIPT_STATUS: JSON.parse(localStorage.getItem('dic')).RECEIPT_STATUS, //回执状态
            VERIFY_STATUS: JSON.parse(localStorage.getItem('dic')).VERIFY_STATUS, //回访状态
            POLICY_STATUS: JSON.parse(localStorage.getItem('dic')).POLICY_STATUS, //保单状态
            DOUBLE_STATUS: JSON.parse(localStorage.getItem('dic')).DOUBLE_STATUS,// 双录状态
        };
    },

    methods: {
        // 处理请求参数
        setRequestParam() {
            let obj = JSON.parse(JSON.stringify(this.searchParams));
            if (obj.date && obj.date[0]) {
                obj.beginUpdateTime = filters.filterTime(obj.date[0], 'YYYY-MM-DD');
                obj.endUpdateTime = filters.filterTime(obj.date[1], 'YYYY-MM-DD');
            }
            obj.policyNo = this.policyNo;
            delete obj.date;
            let { ...params } = obj;
            return params;
        },

        getInitList() {
            this.tableLoading = true;
            this.$http({
                url: `/buz/policyChangeRecord/read/list`,
                type: 'POST',
                data: this.setRequestParam()
            })
                .then(res => {
                    res.data.forEach(item => {
                        // 回访
                        if (item.field == 'receiptStatus') {
                            item.oldStatusName = this.RECEIPT_STATUS[item.oldValue];
                            item.newStatusName = this.RECEIPT_STATUS[item.newValue];
                        } else if (item.field == 'verifyStatus') {
                            //回执
                            item.oldStatusName = this.VERIFY_STATUS[item.oldValue];
                            item.newStatusName = this.VERIFY_STATUS[item.newValue];
                        } else if (item.field == 'status') {
                            //保单状态
                            item.oldStatusName = this.POLICY_STATUS[item.oldValue];
                            item.newStatusName = this.POLICY_STATUS[item.newValue];
                        } else if(item.field == 'doubleRecordStatus') {
                            item.oldStatusName = this.DOUBLE_STATUS[item.oldValue];
                            item.newStatusName = this.DOUBLE_STATUS[item.newValue];
                        }
                    });
                    this.tableData = res.data;
                    this.total = res.total;
                })
                .finally(() => {
                    this.tableLoading = false;
                });
        },

        // 获取变更人
        getChangedBy() {
            this.$http({
                url: `/buz/policyChangeRecord/selectUserInfo`,
                type: 'GET',
                data: {
                    policyNo:this.policyNo
                }
            }).then(res => {
                this.changedByList = res.data;
            });
        },

        // 搜索
        search() {
            this.searchParams.pageNo = 1;
            this.getInitList();
        },

        // 分页
        pageChange(pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getInitList();
        }
    }
};
</script>

<style lang="scss" scoped>
.search-box {
    .input-item {
        width: 300px !important;
    }
}
</style>
